import { Minus, Music2, Plus, Volume2, VolumeX } from 'lucide-react';
import { motion } from 'framer-motion';
import { useBirthdayAudio } from '../hooks/useBirthdayAudio';

export function AudioController() {
  const { started, muted, volume, toggleMute, setVolume, startMusic } = useBirthdayAudio();

  const changeVolume = (change: number) => {
    setVolume(Math.max(0, Math.min(1, Number((volume + change).toFixed(2)))));
  };

  return (
    <motion.div
      className="audio-controller glass"
      initial={{ opacity: 0, scale: 0.8, y: 16 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ delay: 0.6 }}
    >
      <button
        className="audio-main-button"
        aria-label={muted ? 'Unmute background music' : 'Mute background music'}
        onClick={() => {
          if (!started) void startMusic();
          else toggleMute();
        }}
      >
        {!started ? <Music2 size={21} /> : muted ? <VolumeX size={21} /> : <Volume2 size={21} />}
      </button>

      <div className={`music-bars ${muted || !started ? 'paused' : ''}`} aria-hidden="true">
        <i /><i /><i /><i />
      </div>

      <div className="volume-controls" aria-label="Background music volume controls">
        <button
          type="button"
          className="volume-step-button"
          aria-label="Lower background music volume"
          onClick={() => changeVolume(-0.1)}
        >
          <Minus size={16} />
        </button>

        <input
          className="volume-slider"
          aria-label="Background music volume"
          type="range"
          min="0"
          max="1"
          step="0.05"
          value={volume}
          onChange={(event) => setVolume(Number(event.target.value))}
        />

        <button
          type="button"
          className="volume-step-button"
          aria-label="Raise background music volume"
          onClick={() => changeVolume(0.1)}
        >
          <Plus size={16} />
        </button>
      </div>
    </motion.div>
  );
}